import { render, staticRenderFns } from "./AlbumDetailPartial.vue?vue&type=template&id=5a675546&lang=pug&"
import script from "./AlbumDetailPartial.vue?vue&type=script&lang=js&"
export * from "./AlbumDetailPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports